import type { ReactElement } from 'react';

import { Button, Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../hooks/reduxHooks';

import styles from './Error.module.css';

function Error(): ReactElement {
  const { t } = useTranslation();
  const { isDarkMode } = useAppSelector((state) => state.settings);

  const handleReloadClick = () => window.location.reload();

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap="8"
      py={{ initial: '75px', sm: '110px' }}>
      <img
        src={isDarkMode ? '/imgs/general/error-dark.png' : '/imgs/general/error-light.png'}
        className={styles.image}
      />
      <Flex direction="column" align="center" gap="2">
        <Heading size={{ initial: '6', md: '8' }} align="center">
          {t('Sorry, something went wrong')}
        </Heading>
        <Text size={{ initial: '3', md: '2' }} weight="regular" color="gray" align="center">
          {t(
            'An unexpected error has occurred. If reloading the page does not fix it, please contact Rango support.',
          )}
        </Text>
      </Flex>
      <Button
        id="error-page-reload-btn"
        size={{ initial: '3', md: '4' }}
        onClick={handleReloadClick}
        className={styles.actionButton}>
        {t('Reload')}
      </Button>
    </Flex>
  );
}

export default Error;
